enum AutocompleteAddressActionType {
    AUTOCOMPLETE_ADDRESS_TOGGLE_SHIMMER = "AUTOCOMPLETE_ADDRESS_TOGGLE_SHIMMER"
}

export default AutocompleteAddressActionType;